import { useEffect, useState } from 'react';
import api from '../utils/api';
import bundled from '../version.json';

const POLL_INTERVAL_MS = 60_000;

// Compares server-reported version against the version baked into this bundle.
// Returns the latest version when an update is available, otherwise null.
export default function useVersionCheck() {
  const [latest, setLatest] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      try {
        const { data } = await api.get('/version');
        if (cancelled || !data?.version) return;
        const isNewer = data.version !== bundled.version || (data.build || 0) > (bundled.build || 0);
        if (isNewer) setLatest(data);
        else setLatest(null);
      } catch { /* offline or endpoint missing — ignore */ }
    };

    check();
    const id = setInterval(check, POLL_INTERVAL_MS);
    const onFocus = () => check();
    window.addEventListener('focus', onFocus);

    return () => {
      cancelled = true;
      clearInterval(id);
      window.removeEventListener('focus', onFocus);
    };
  }, []);

  return { current: bundled, latest, updateAvailable: !!latest };
}
